import React from 'react'
import Footer from './Footer'

export default function Terms() {
  return (
    <div>
      <div class="terms-container">
        <h1 class="terms-title">Terms of Service</h1>
        <p class="terms-text">Welcome to Insurance Advisors. Please read these Terms of Service ("Terms") carefully as they contain important information regarding your use of this website and services. By accessing or using our services, you agree to be bound by these Terms.</p>

        <h2 class="terms-heading"><u>Orders and Payments:-</u></h2>
        <p class="terms-text">Your orders, payments, data processing, and insurance policies are subject to the terms and conditions mentioned here. Insurance Advisors serves as an intermediary for insurance policies available through this site.</p>

        <h2 class="terms-heading"><u>Issuance & Claims:-</u></h2>
        <p class="terms-text">This website is operated by Insurance Advisors, which is authorized to facilitate the sale of insurance products listed here. We do not underwrite or settle claims ourselves; rather, we connect you with the insurance providers. All insurance policies you purchase through this website are issued directly by the relevant insurance companies. In the case of a claim, you must contact the respective insurance company directly. By purchasing insurance through us, you release us from any legal involvement in claims processing or settlements.</p>
        <p class="terms-text">We reserve the right to cancel your order in case of any pricing errors or technical issues.</p>

        <h2 class="terms-heading"><u>Your Data:-</u></h2>
        <p class="terms-text">You agree to provide all necessary documents and accurate information to process your insurance order. We prioritize the security of your data, storing it securely and sharing it only with the selected insurance company as required to fulfill your order. We will not sell or distribute your personal information. We may, however, contact you regarding future products, updates, or services.</p>

        <h2 class="terms-heading"><u>Refunds:-</u></h2>
        <p class="terms-text">All insurance products are non-refundable. In some cases, insurance companies may approve a refund if there is an official rejection letter from the relevant embassy or authority. A refund, if applicable, may incur a deduction of up to 75% of the original amount to cover administrative fees and processing costs.</p>

        <h2 class="terms-heading"><u>Contact Us:-</u></h2>
        <p class="terms-text">If you have any questions about these Terms, please contact us at <a href="mailto:support@insuranceadvisors.pk">support@insuranceadvisors.pk</a>.</p>
    </div>

<div>
    <Footer></Footer>
</div>

    </div>
  )
}
